// The wrappers of react-step-wizard 5.3.11 (classes rsw_2Y and rsw_3G), which the layout relies on:
// components/calculators/Nav.module.scss pads the div after the nav and puts the nav above the step.
.container {
  position: relative;
}

.step {
  position: relative;
  z-index: 1;
}
